import { sortTypes, sortValues } from '@jetshop/core/components/SortOrder/SortOrderContainer';
import SortOrderContext from '@jetshop/core/components/SortOrder/SortOrderContext';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
class SortOrder extends React.PureComponent {
    render() {
        // Mutate sort order obj to include asc/desc & appropriate text
        // eg { text: 'Price low to high', direction: 'ASCENDING' }
        const mappedSortOrder = this.props.sortOrders.reduce((sorts, curr) => {
            const mutatedSorts = sortValues[sortTypes[curr.value]].map(type => {
                return Object.assign(Object.assign({}, curr), { text: (React.createElement("div", null,
                        curr['text'],
                        " ",
                        type.text)), direction: type.direction });
            });
            return [...sorts, ...mutatedSorts];
        }, []);
        return (React.createElement(ErrorBoundary, { component: PassThrough },
            React.createElement(SortOrderContext.Consumer, null, ({ changeSortOrder, direction, sortOrder }) => {
                return this.props.children({
                    changeSortOrder,
                    direction,
                    sortOrder,
                    mappedSortOrder
                });
            })));
    }
}
export default withRouter(SortOrder);
//# sourceMappingURL=SortOrder.js.map